module.exports = __webpack_public_path__ + "static/img/shbf.3455617.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shbf.png
// module id = weK1
// module chunks = 1